const { defaultLanguage } = require('../../prismic-configuration')

/**
 * The Link Resolver used for the Prismic repository. This function converts a
 * Prismic document to a URL within your app. It is used throughout your app to
 * resolve document links and support editor previews.
 *
 * {@link https://prismic.io/docs/technologies/link-resolver-gatsby}
 *
 * @param doc Prismic document to resolve to a URL within your app.
 *
 * @returns URL for the provided Prismic document.
 *
 * @type import('@prismicio/helpers').LinkResolverFunction
 */

const SOLUTIONS = 'solutions'
const STORY_PAGE = 'story_page'
const AUTHOR_PAGE = 'author_page'

const defaultRoute = (isMainLanguage, doc, mainPath = '') =>
  isMainLanguage
    ? `${mainPath}/${doc.uid}`
    : `/${doc.lang}${mainPath}/${doc.uid}`

exports.AUTHOR_PAGE = AUTHOR_PAGE

exports.linkResolver = (doc) => {
  const isMainLanguage = doc.lang === defaultLanguage
  switch (doc.type) {
    case 'homepage': {
      return isMainLanguage ? '/' : `/${doc.lang}`
    }

    case 'page': {
      return defaultRoute(isMainLanguage, doc)
    }

    case SOLUTIONS: {
      return defaultRoute(isMainLanguage, doc, `/${SOLUTIONS}`)
    }
    case STORY_PAGE: {
      return defaultRoute(isMainLanguage, doc, '/success-stories')
    }

    case 'careers_page': {
      return defaultRoute(isMainLanguage, doc)
    }

    case 'about_us_page': {
      return defaultRoute(isMainLanguage, doc)
    }

    case 'technology_page_template': {
      return defaultRoute(isMainLanguage, doc, '/technology')
    }

    case 'privacy_page': {
      return defaultRoute(isMainLanguage, doc, '/legal')
    }

    case 'price_page': {
      return defaultRoute(isMainLanguage, doc)
    }

    case 'article_page': {
      return defaultRoute(isMainLanguage, doc, `/${doc.data?.type}`)
    }

    case 'articles_overview_page': {
      return defaultRoute(isMainLanguage, doc)
    }

    case 'articles_search_page': {
      return defaultRoute(isMainLanguage, doc, `/${doc.data?.type}`)
    }

    case AUTHOR_PAGE: {
      return defaultRoute(isMainLanguage, doc, '/author')
    }

    case 'person': {
      return defaultRoute(isMainLanguage, doc, '/author')
    }

    case 'contact_page': {
      return defaultRoute(isMainLanguage, doc)
    }

    case 'job_details_page': {
      return defaultRoute(isMainLanguage, doc, '/careers')
    }

    default:
      return '/'
  }
}
